import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import IcoMoon from 'react-icomoon';
import iconSet from '../../../assets/icons/mu-icomoon.json';
import { spaces } from '../../../assets/styles/themes/tokens';

/**
 * This component is used to display a card when a video is not available.
 * Since it is an old surviving component converted to MUI, 
 * we are using custom styling and values instead of design system.
 */
const VideoNotAvailableCard = () => {
  const { t } = useTranslation();

  return (
    <Box
      data-testid='video-not-available-content'
      sx={{
        backgroundColor: '#44555d',
        color: '#fff',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        textAlign: 'center',
        width: '100%',
        height: '100%',
        padding: `${spaces.md} ${spaces.sm}`,
      }}
    >
      <Box
        sx={{
          marginBottom: spaces.md,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '& svg': {
            width: '28px',
            height: '28px',
          },
        }}
      >
        <IcoMoon
          iconSet={iconSet}
          icon='camera-off'
          viewBox='0 0 28 28'
        />
      </Box>
      <Typography
        sx={{
          fontFamily: 'Roboto, sans-serif',
          fontSize: '20px',
          fontWeight: 'bold',
          lineHeight: 'inherit',
          color: '#fff',
          marginBottom: spaces.xs,
        }}
      >
        {t('Video unavailable')}
      </Typography>
      <Typography
        sx={{
          fontFamily: 'Roboto, sans-serif',
          lineHeight: 'inherit',
          color: '#fff',
          fontSize: '16px',
          fontWeight: '400',
          marginBottom: spaces.md,
          letterSpacing: 'normal',
        }}
      >
        {t('Unfortunately, the video is currently not available due to the type of your license.')}
      </Typography>
    </Box>
  );
};

export default VideoNotAvailableCard;
